import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbGcs: BowlBlock = withIntegration(options.slug.llmKbGcs, [
  {
    name: 'remoteUrl',
    type: 'withText',
    required: true,
  },
  {
    name: 'serviceAccountKey',
    type: 'withText',
    required: true,
  },
  {
    name: 'recursive',
    type: 'checkbox',
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
